/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Change_Col_TypeInputs */

const en_po_change_col_type = /** @type {(inputs: Po_Change_Col_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposal`)
};

/**
* | output |
* | --- |
* | "Proposal" |
*
* @param {Po_Change_Col_TypeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_change_col_type = /** @type {((inputs?: Po_Change_Col_TypeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Change_Col_TypeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_change_col_type(inputs)
});